"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentenceBuildEvaluator = void 0;
const utils_1 = require("./utils");
class SentenceBuildEvaluator {
    async evaluate(submission, activity) {
        const targetSentence = (0, utils_1.normalizeWhitespace)(String(activity.config.sentence ?? '')).toLowerCase();
        const structured = submission.structuredData;
        const studentSentence = (0, utils_1.normalizeWhitespace)(String(submission.finalText ??
            structured?.answer ??
            structured?.builtSentence ??
            '')).toLowerCase();
        const isCorrect = studentSentence === targetSentence;
        const score = isCorrect ? 100 : 0;
        const feedback = isCorrect
            ? 'Excellent sentence building!'
            : 'That is not the correct sentence. Try arranging the words in the right order.';
        return {
            score,
            maxScore: 100,
            isCorrect,
            feedback,
            breakdown: [
                { name: 'Sentence Accuracy', score, maxScore: 100, feedback: isCorrect ? 'Exact match' : 'Words out of order or missing' },
            ],
            skills: [{ key: `sentence:${targetSentence.slice(0, 30)}`, label: 'Sentence Building' }],
            label: 'Sentence Score',
        };
    }
}
exports.SentenceBuildEvaluator = SentenceBuildEvaluator;
